<template>
  <div class='page_content'>
    <div class="page_content_top">
      <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo"
        @openFormDesign="openFormDesign"></v-button>
      <div class="page_content_top_line">
        <v-search v-if="pageShowData.jurHead" :flagList="['cmIntype']" :searchList="pageShowData.jurHead.jurconfigform"
          :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
          <template slot="searchInput" slot-scope="{formOneValue}">
            <el-select clearable size="mini" v-if="formOneValue.entityField == 'cmIntype'"
              v-model="getRequestData[formOneValue.entityField]" placeholder="请选择">
              <el-option v-for="item in lxList" :key="item.key" :label="item.diName" :value="item.diName">
              </el-option>
            </el-select>
          </template>
        </v-search>
      </div>
    </div>
    <div class="page_content_center">
      <el-table v-if="pageShowData.jurTableVo" @selection-change="handleSelectionChange" class="table1" stripe
        :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%"
        highlight-current-row size="mini">
        <el-table-column type="selection" width="40">
        </el-table-column>
        <el-table-column v-if="tableValye.isShow == 1" align="center"
          v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" show-overflow-tooltip
          :min-width="tableValye.fieldWeight" :prop="tableValye.entityField" :label="tableValye.showField">
          <template slot-scope="scope">
            <span v-if="tableValye.fieldType == 'date'">
              <span v-if="scope.row[tableValye.entityField]">
                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
              </span>
            </span>
            <el-tag size="mini" v-else-if="tableValye.entityField == 'isWms'">
              {{ scope.row.isWms == 0 ? '否' : '是' }}
            </el-tag>
            <span v-else-if="tableValye.isRift == 1">
              <a @click="toDetail(scope.row[tableValye.riftField])">{{
                scope.row[tableValye.entityField]
              }}</a>
            </span>
            <el-tag size="mini" v-else-if="tableValye.entityField == 'woamState'">{{
              $common.getIsGsp(tableValye.formatterContent, scope.row.woamState) }}</el-tag>
            <el-tag size="mini" v-else-if="tableValye.fieldType == 'formatter'">{{
              $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
            <span v-else>
              {{ scope.row[tableValye.entityField] }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_content_bottom">
      <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
        @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
      <SearchScheme ref="SearchScheme" :id="seId" :smId="cmId" :parentSearchData="parentSearchData"
        @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>

    <el-drawer :close-on-press-escape="true" :visible.sync="dialogVisible" :with-header="false"
      append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
      <desuLimit v-if="dialogVisible" ref="desuLimit" @drawerCancel="drawerCancel" :actionData="actionData">
      </desuLimit>
    </el-drawer>
    <customDesign ref="customDesign"></customDesign>

  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue"
import desuLimit from "@/components/desuLimit.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { desuLimit },
  data() {
    //这里存放数据
    return {
      tableHeight: 0,
      selectedDataIndex: 0,
      getRequestData: {
        bgmName: '',
        bussinessId: '',
        manufacturer: '',
        creater: '',
        ormId: 0,
        spec: '',
        page: 1,
        rows: 30,
        start: '',	//开始上一个月
        end: '',	//当天最后时间
      },
      goodsData: [],
      options: [],
      addForm: {
        glcId: ''
      },
      dialogVisible: false,
      returnData: {
        pages: 0,  // 总页数
        total: 0,  // 总条数
        pageNum: 0,  // 当前页数
        list: []
      },
      sField: '',
      buttonList: [],
      pageShowData: [],
      formDataList: [],
      selectedDataIndex: 0,

      seTitle: "",//检索
      DialogVisible: false,
      seWidth: '0',
      seId: 0,
      cmId: 0,
      showStatus: false,
      actionData: {},
      parentSearchData: {},
      multipleSelection: [],
      lxList: []
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    'getRequestData.cmName': {
      handler: function (newValue, oldValue) {
        if (newValue == '') {
          this.getRequestData.cmId = ''
        }
      },
      deep: true,
    }
  },
  //方法集合
  methods: {
    getlxList() {
      this.$http.getCateDictionariesData({ ids: [38] }).then(res => {
        this.lxList = res.result
      })
    },
    cancel() {
      this.dialogVisible = false
      this.addForm.glcId = ''
      this.goodsData = []
    },
    delGoods() {
      if (this.goodsData.length > 0) {
        this.goodsData.splice(this.selectedDataIndex, 1)
      } else {
        this.$message.error('暂无可删除的数据')
      }
    },
    submit() {
      if (this.goodsData.length == 0) {
        this.$message.error("请选择商品!")
        return
      }
      this.$http.addqueryClassifyDetailData({
        glcId: this.addForm.glcId,
        bgmIds: this.goodsData.map(item => {
          return item.bgmId
        })
      }).then(res => {
        if (res.status == 200) {
          this.$message.success(res.message)
          this.goodsData = []
          this.getDataList()
          this.dialogVisible = false
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    searchDataList() {
      this.$http.queryClassifyData({ classifyName: '' }).then(res => {
        if (res.status == 200) {
          this.options = res.result
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 子组件触发
    drawerCancel() {
      this.dialogVisible = false
      this.getDataList()
    },
    // 点击穿透字段 传参单号
    toDetail(orderId) {
      if (orderId) {
        // 设置为true 打开穿透组件首页    
        var isPenetrate = true
        // 设置缓存 存入点击单号
        this.resetSetItem('penetrateOrderId', orderId);
        // 与父级跨域通信 传递isPenetrate参数
        window.parent.postMessage({  //向窗口发送MessageEvent消息
          cmd: 'returnFormJson',
          params: { isPenetrate } //参数
        }, '*');
      }
    },
    // 检索Id, 索引(表格中), 标识
    openSearch({ sId, index, type, sField }) {
      this.DialogVisible = true
      this.seId = sId
      this.sField = sField
      this.parentSearchData[type] = this.getRequestData[type]
    },
    //检索带回数据
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        if (this.goodsData.findIndex(item => item.bgmId == val.bgmId) == -1) {
          this.goodsData.push(val)
        } else {
          this.paramValue(val)
        }
      }
    },
    // 赋值字段
    paramValue(val) {
      if (this.sField) {
        let arr = this.sField.split(',')
        arr.forEach(item => {
          this.getRequestData[item] = val[item]
        })
      }
    },
    getSeWidth(e) {
      // console.log(e);
      this.seWidth = e + "%";
    },
    getWidth(e) {
      // console.log(e);
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      // console.log(e);
      this.seTitle = e;
    },
    isShowData(name, value) {
      switch (name) {
        case 'customerList':
          var dataInfo = sessionStorage.getItem('selectCustomerData')
          if (dataInfo) {
            dataInfo = JSON.parse(dataInfo)
            this.getRequestData.cmId = dataInfo.cmId
            this.getRequestData.cmName = dataInfo.cmName
          }

          break;

        default:
          this.getRequestData[name] = value

      }
    },

    async getPageInfo() {
      var pathId = parent.getMenuInfo(this.$route.path)
      let responseData = await this.$http.getJur({ ids: [pathId.jurId] })
      if (responseData.status == 200) {
        this.getButtonList()
        this.pageShowData = responseData.result
        this.formDataList = this.pageShowData
        var obj = {}
        if (this.pageShowData.jurHead) {
          obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
        } else {
          obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
        }
        for (const key in obj) {
          this.$set(this.getRequestData, key, obj[key])
        }
        this.getDataList()
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },
    // 动作集合
    actionSet(actionData) {
      console.log(actionData)
      switch (actionData.actionType) {
        case 0:
          this.dialogVisible = true
          console.log(this.formDataList)
          this.actionData = {
            cate: 0, formData: this.formDataList.jurFormVoList,
            oldData: '', orderId: '', printSouce: '',
            printJurId: '', type: 'one',
          }
          break;
        case 1:

          if (this.multipleSelection.length != 1) {
            return this.$message({
              message: '请选中一条数据修改',
              type: 'error'
            });
          }
          this.queryDetails(1)
          break;
        case 2:
          if (this.multipleSelection.length == 0) {
            return this.$message({
              message: '请至少选中一条数据删除',
              type: 'error'
            });
          }
          this.$confirm('此操作将永久删除选中数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$http.delXianXiaoGoods({
              ids: this.multipleSelection.map(item => {
                return item.sdId
              })
            }).then(res => {
              if (res.status == 200) {
                this.$message.success(res.message)
                this.getDataList()
              } else {
                this.$message.error(res.message)
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });

          break;
        case 3:
          if (this.multipleSelection.length != 1) {
            return this.$message({
              message: '请选中一条数据查看',
              type: 'error'
            });
          }
          this.queryDetails(3)
          break;
      }
    },
    async queryDetails(val) {
      var dataInfo = JSON.parse(JSON.stringify(this.multipleSelection[0]))
      const res = await this.$http.goodsunitlimitqueryById({ ids: [dataInfo.ssId] })
      console.log(res);

      if (res.status == 200) {
        this.actionData = {
          cate: val,
          formData: this.formDataList.jurFormVoList,
          oldData: res.result,
          printSouce: '',
          printJurId: '',
          type: 'one'
        }
        this.dialogVisible = true
      } else {
        this.$message.error(res.message)
      }
    },
    openFormDesign() {
      let pathInfo = parent.getMenuInfo(this.$route.path);
      this.$refs["customDesign"].openBox(
        pathInfo.jurId,
        this.pageShowData,
        pathInfo.jurName
      );
    },
    // 数据搜索
    searchData() {
      this.getRequestData.page = 1
      this.getDataList()
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val
      this.getDataList()
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1
      this.getRequestData.rows = val
      this.getDataList()
    },


    // 获取数据列表
    async getDataList() {
      let responseData = await this.$http.queryClassifyDetailData(this.getRequestData)
      if (responseData && responseData.status == 200) {
        let resData = JSON.parse(JSON.stringify(responseData))
        this.returnData.list = resData.result.list
        this.returnData.pages = resData.result.pages
        this.returnData.total = resData.result.total
        this.returnData.pageNum = resData.result.pageNum
        this.selectedDataIndex = 0

      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },


    //获取状态
    getIsGsp(str, val) {
      try {
        str && str.replace(/\\/g, '')
        let arr = JSON.parse(str)
        let len = arr.length
        let newStr = ''
        for (let i = 0; i < len; i++) {
          if (arr[i].key === val) {
            newStr = arr[i].value
            break;
          }
        }
        return newStr
      } catch (ex) {
        return str
      }
    },
    // 获取按钮权限
    async getButtonList() {
      this.buttonList = await this.$common.getActionButton()
      
    },
},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getlxList()
    this.getPageInfo()
    this.searchDataList()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_content_tag {
  margin-right: 1rem;
}

.el-tabs--border-card_new {
  height: 85vh;
  overflow-y: scroll;
}

.dialog-footer {
  height: 20px;
  padding: 0 30%;
}
</style>
